<template>
  <section id="admin-filter">
    <h4>Routing rules filter</h4>
    <div class="form-group">
      <label for="rr-oc-filter" class="form-label">Description</label>
      <input type="text" v-model="entity.description" class="form-control" id="rr-oc-filter"/>
    </div>
    <div class="form-group">
      <label class="form-label">Origin Location</label>
      <autocomplete
        :dataset="locationSearchResults"
        title="Origin Location"
        placeHolder="Type to search"
        :initVal="entity.originLocation"
        v-on:changing="data => locationSearchText = data"
        :fnFormatText="displayLocation"
        :fnSelectValue="displayLocation"
        v-on:selection-made="selectOrigin"
      ></autocomplete>
    </div>
    <div class="form-group">
      <label for="rr-oc-filter" class="form-label">Origin Country</label>
      <select v-model="entity.originCountry" class="form-control" id="rr-cc-filter">
        <option v-for="(opt, i) in countries" :value="opt.id">{{ opt.name }}</option>
      </select>
    </div>
    <div class="form-group">
      <label class="form-label">Destination Location</label>
      <autocomplete
        :dataset="locationSearchResults"
        title="Destination Location"
        placeHolder="Type to search"
        :initVal="entity.destinationLocation"
        v-on:changing="data => locationSearchText = data"
        :fnFormatText="displayLocation"
        :fnSelectValue="displayLocation"
        v-on:selection-made="selectDestination"
      ></autocomplete>
    </div>
    <div class="form-group">
      <label for="rr-dc-filter" class="form-label">Destination Country</label>
      <select v-model="entity.destinationCountry" class="form-control" id="rr-dc-filter">
        <option v-for="(opt, i) in countries" :value="opt.id">{{ opt.name }}</option>
      </select>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  import HelperMixin from '../../mixins/Helpers'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  export default {
    name: 'RoutingRuleFilter',
    mixins: [ FilterMixin, HelperMixin ],
    data () {
      return {
        entity: {
          originLocation: '',
          destinationLocation: '',
          originCountry: '',
          destinationCountry: '',
          description: ''
        }
      }
    },
    components: {
      Autocomplete
    },
    methods: {
      selectOrigin (o) {
        this.entity.originLocation = o
        this.locationSearchText = ''
        this.locationSearchResults = []
      },
      selectDestination (d) {
        this.entity.destinationLocation = d
        this.locationSearchText = ''
        this.locationSearchResults = []
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/RoutingRule/RoutingRuleFilter.vue